import React from 'react';
import { ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { useSidebarPermissions } from '../hooks/useSidebarPermissions';

const NavigationItem = ({ item, selectedItem, onNavigation, userType }) => {
  const { isSubmenuItemDisabled, getTooltipMessage } = useSidebarPermissions();
  
  if (!item || !item.name) {
    return null;
  }
  
  const isSelected = selectedItem === item.name;
  const isDisabled = isSubmenuItemDisabled(item.name, item.link);
  
  // Keep help support styling logic
  const isHelpSupportItem = ['FAQ', 'Help us Improve', 'Update Subscription', 'Support'].includes(item.name) ||
    item.link?.includes('/dashboard/help-and-support');
  
  const handleClick = () => {
    if (!isDisabled && onNavigation && typeof onNavigation === 'function') {
      onNavigation(item);
    }
  };
  
  const buttonContent = (
    <ListItemButton
      onClick={handleClick}
      disabled={isDisabled}
      className={`${
        isSelected 
          ? isHelpSupportItem 
            ? "bg-gray-300 text-gray-800 shadow-md rounded-lg"  
            : "bg-gray-200 text-black shadow-md rounded-lg" 
          : isDisabled
            ? "text-gray-400 cursor-not-allowed rounded-lg"
            : "text-gray-800 hover:bg-gray-300 rounded-lg"
      }`}
      sx={{
        '& .MuiListItemIcon-root': { minWidth: '24px', marginRight: '6px' },
        borderRadius: '8px',
        '&:hover': { 
          borderRadius: '8px',
          backgroundColor: isDisabled ? 'transparent' : undefined
        },
        '&.Mui-disabled': {
          opacity: 0.6
        }
      }}
    >
      <ListItemIcon>
        {item.icon && typeof item.icon === "string" ? (
          <img
            src={item.icon}
            alt={item.name}
            className={`w-4 h-4 filter brightness-0 ${isDisabled ? 'opacity-50' : ''}`}
            onError={(e) => { e.target.onerror = null; e.target.style.display = "none"; }}
          />
        ) : item.icon ? (
          <item.icon className={`w-4 h-4 ${isDisabled ? 'opacity-50' : ''} ${isSelected ? (isHelpSupportItem ? "text-gray-800" : "text-black") : "text-gray-800"}`} />
        ) : null}
      </ListItemIcon>
      <ListItemText 
        primary={item.name} 
        className={isSelected ? (isHelpSupportItem ? "text-gray-800" : "text-black") : isDisabled ? "text-gray-400" : "text-gray-800"}
        primaryTypographyProps={{ fontSize: "0.9rem", fontWeight: 400, lineHeight: 1.2 }}
      />
    </ListItemButton>
  );
  
  return (
    <ListItem disablePadding className="mb-0">
      {isDisabled && getTooltipMessage(item.name, '') ? (
        <Tooltip 
          title={getTooltipMessage(item.name, '')} 
          placement="right"
          arrow
        >
          <span>{buttonContent}</span>
        </Tooltip>
      ) : (
        buttonContent
      )}
    </ListItem>
  );
};

export default NavigationItem; 